import { RoleGroup } from "@/components/people/RoleGroup";
import { PersonCard } from "@/components/people/PersonCard";

/** A team that is not a unit's — Management, or the Pravartanam partners. */
export const GroupSection = ({ id, title, note, groups, card, empty, onAdd }) => (
  <section id={id} data-testid={id} className="scroll-mt-24">
    <div className="flex flex-wrap items-end justify-between gap-3 border-b-2 border-foreground pb-2">
      <div>
        <h2 className="font-display text-2xl font-black tracking-tight">{title}</h2>
        <p className="mt-1 text-xs text-muted-foreground">{note}</p>
      </div>
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          data-testid={`${id}-add`}
          className="border border-primary px-3 py-1.5 font-display text-[10px] font-bold uppercase tracking-widest text-primary transition-colors duration-200 hover:bg-primary hover:text-primary-foreground"
        >
          Add to {title}
        </button>
      )}
    </div>
    <div className="mt-3 space-y-4">
      {groups.map((g) => (
        <RoleGroup key={g.role} group={g} scope={id} card={card} />
      ))}
      {!groups.length && (
        <p className="text-sm text-muted-foreground" data-testid={`${id}-empty`}>
          {empty}
        </p>
      )}
    </div>
  </section>
);

/** People on the portal who have no team role or no unit yet. */
export const WaitingSection = ({ people, card }) => (
  <section id="people-waiting" data-testid="people-waiting" className="scroll-mt-24 border border-[hsl(var(--watch))] p-4">
    <div className="label-caps text-[hsl(var(--watch))]">Waiting to be placed · {people.length}</div>
    <p className="mt-1 text-xs text-muted-foreground">
      On the portal, but with no team role or no unit yet. Open one and pick the team and the role.
    </p>
    <div className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
      {people.map((p) => (
        <PersonCard key={p.key} p={p} {...card} />
      ))}
    </div>
  </section>
);
